// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TranslateRouteImport } from './routes/translate'
import { Route as TopUpRouteImport } from './routes/top-up'
import { Route as SubscribeRouteImport } from './routes/subscribe'
import { Route as SkillsRouteImport } from './routes/skills'
import { Route as SchedulesRouteImport } from './routes/schedules'
import { Route as BalanceRouteImport } from './routes/balance'
import { Route as SplatRouteImport } from './routes/$'
import { Route as PolarRouteRouteImport } from './routes/polar/route'
import { Route as TopUpIdRouteImport } from './routes/top-up_.$id'
import { Route as SkillsNewRouteImport } from './routes/skills_.new'
import { Route as SkillsIdRouteImport } from './routes/skills_.$id'
import { Route as ShareIdRouteImport } from './routes/share_.$id'
import { Route as ActionIdRouteImport } from './routes/action_.$id'
import { Route as PolarToppedRouteImport } from './routes/polar/topped'
import { Route as PolarSubscribedRouteImport } from './routes/polar/subscribed'
import { Route as SkillsInnateKeyRouteImport } from './routes/skills_.innate_.$key'
import { Route as ApiTranslateSessionRouteImport } from './routes/api/translate/session'

const TranslateRoute = TranslateRouteImport.update({
            id: '/translate',path: '/translate',getParentRoute: () => rootRouteImport
          })
const TopUpRoute = TopUpRouteImport.update({
            id: '/top-up',path: '/top-up',getParentRoute: () => rootRouteImport
          })
const SubscribeRoute = SubscribeRouteImport.update({
            id: '/subscribe',path: '/subscribe',getParentRoute: () => rootRouteImport
          })
const SkillsRoute = SkillsRouteImport.update({
            id: '/skills',path: '/skills',getParentRoute: () => rootRouteImport
          })
const SchedulesRoute = SchedulesRouteImport.update({
            id: '/schedules',path: '/schedules',getParentRoute: () => rootRouteImport
          })
const BalanceRoute = BalanceRouteImport.update({
            id: '/balance',path: '/balance',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const PolarRouteRoute = PolarRouteRouteImport.update({
            id: '/polar',path: '/polar',getParentRoute: () => rootRouteImport
          })
const TopUpIdRoute = TopUpIdRouteImport.update({
            id: '/top-up_/$id',path: '/top-up/$id',getParentRoute: () => rootRouteImport
          })
const SkillsNewRoute = SkillsNewRouteImport.update({
            id: '/skills_/new',path: '/skills/new',getParentRoute: () => rootRouteImport
          })
const SkillsIdRoute = SkillsIdRouteImport.update({
            id: '/skills_/$id',path: '/skills/$id',getParentRoute: () => rootRouteImport
          })
const ShareIdRoute = ShareIdRouteImport.update({
            id: '/share_/$id',path: '/share/$id',getParentRoute: () => rootRouteImport
          })
const ActionIdRoute = ActionIdRouteImport.update({
            id: '/action_/$id',path: '/action/$id',getParentRoute: () => rootRouteImport
          })
const PolarToppedRoute = PolarToppedRouteImport.update({
            id: '/topped',path: '/topped',getParentRoute: () => PolarRouteRoute
          })
const PolarSubscribedRoute = PolarSubscribedRouteImport.update({
            id: '/subscribed',path: '/subscribed',getParentRoute: () => PolarRouteRoute
          })
const SkillsInnateKeyRoute = SkillsInnateKeyRouteImport.update({
            id: '/skills_/innate_/$key',path: '/skills/innate/$key',getParentRoute: () => rootRouteImport
          })
const ApiTranslateSessionRoute = ApiTranslateSessionRouteImport.update({
            id: '/api/translate/session',path: '/api/translate/session',getParentRoute: () => rootRouteImport
          })





const PolarRouteRouteChildren = {
  PolarSubscribedRoute: PolarSubscribedRoute,PolarToppedRoute: PolarToppedRoute
}

const PolarRouteRouteWithChildren = PolarRouteRoute._addFileChildren(PolarRouteRouteChildren)

const rootRouteChildren = {
  PolarRouteRoute: PolarRouteRouteWithChildren,SplatRoute: SplatRoute,BalanceRoute: BalanceRoute,SchedulesRoute: SchedulesRoute,SkillsRoute: SkillsRoute,SubscribeRoute: SubscribeRoute,TopUpRoute: TopUpRoute,TranslateRoute: TranslateRoute,ActionIdRoute: ActionIdRoute,ShareIdRoute: ShareIdRoute,SkillsIdRoute: SkillsIdRoute,SkillsNewRoute: SkillsNewRoute,TopUpIdRoute: TopUpIdRoute,ApiTranslateSessionRoute: ApiTranslateSessionRoute,SkillsInnateKeyRoute: SkillsInnateKeyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)